import HeroSection from "@/components/hero-section";
import AboutSection from "@/components/about-section";
import ProjectsSection from "@/components/projects-section";
import SkillsSection from "@/components/skills-section";
import BlogSection from "@/components/blog-section";
import ContactSection from "@/components/contact-section";
import Navigation from "@/components/navigation";
import Footer from "@/components/footer";
import MatrixBackground from "@/components/matrix-background";

export default function Landing() {
  return (
    <div className="min-h-screen bg-dark-bg text-white">
      <MatrixBackground />
      <Navigation />
      <HeroSection />
      <AboutSection />
      <ProjectsSection />
      <SkillsSection />
      <BlogSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
